import { Pipe, PipeTransform } from '@angular/core';

import { EnclosureIP } from '../../shared/models/prisma-xs.model';

@Pipe({
    name: 'completeMultimediaNotAvailableForEnclosureType',
    standalone: false
})
export class CompleteMultimediaNotAvailableForEnclosureTypePipe implements PipeTransform {

  transform(enclosureIP: EnclosureIP, cannotBePlacedOn280: boolean): boolean {
    return this.enclosureTypeIs280(enclosureIP) && cannotBePlacedOn280;
  }

  enclosureTypeIs280(enclosureIP: EnclosureIP) {
    return enclosureIP === EnclosureIP.IP55;
  }

}
